export default {
  pl: {
    appName_: 'Zodiac',
    back_: 'Wstecz',
    close_: 'Zamknij',
    loginScreen: {
      username_: 'Nazwa użytkownika',
      password_: 'Hasło',
      helloMessage_: 'Witaj',
      message_: 'Zaloguj się:',
      forgotPassword_: 'Zapomniałeś hasła?',
      noAccountMessage_: 'Nie masz jeszcze konta? Zarejestruj się.',
      button_: 'Zaloguj się!',
      rememberMe_: 'Pamiętaj mnie',
    },
    loader_: 'Chyba jest problem z serwerem. Próba połączenia jeszcze raz...',
    loaderError_: 'Nie można pobrać danych',
    requiredField: '* - to pole jest wymagane',
    sidebar: {
      dashboard_: 'Dashboard',
      admin_: 'Panel admina',
      settings_: 'Ustawienia',
      uspace_: 'Historia',
      airspace_: 'Przestrzenie',
      profile_: 'Profil',
      uspace: {
        operations_: 'Operacje',
        missions_: 'Misje',
      },
      airspace: {
        zones_: 'Strefy',
        corridors_: 'Korytarze',
      },
      settings: {
        userSettings_: 'Ustawienia użytkownika',
        dashboardSettings_: `Konfiguracja Dashboard'u`,
        profileSettings_: 'Ustawienia profilu',
        contact_: 'Kontakt',
        logout_: 'Wyloguj się',
      },
      admin: {
        organizations_: 'Organizacje',
        users_: 'Użytkownicy',
        subscriptions_: 'Subskrybcje',
        systemSettings_: 'Ustawienia systemu',
      },
      operations_: 'Operacje',
      zones_: 'Strefy',
      missions_: 'Misje',
      approvedAreas_: 'Korytarze',
      adminZone_: 'Panel admina',
      heightUnit_: 'Jednostka wysokości',
    },
    resetPassword: {
      emailPage: {
        header_: 'Wpisz adres email na który wyślemy link do zmiany hasła',
        email_: 'Email',
        button_: 'Wyślij',
        sending_: 'Wysyłam',
        successMsg_: 'Mail został wysłany na podany adres. Sprawdź skrzynkę',
        backMsg_: 'Powrót do strony logowania',
        resetPassword_: 'Reset hasła',
        confirmMsg_: 'Czy chcesz zresetować hasło?',
        cancel_: 'Anuluj',
        faildMsg_: 'Coś poszło nie tam. Spróbuj jeszcze raz',
        close_: 'Zamknij',
      },
      setPassword: {
        header_: 'Ustaw nowe hasło i potwierdź je',
        password_: 'Nowe hasło',
        rePassword_: 'Powtórz hasło',
        button_: 'Zapisz',
        successMsg_: 'Hasło zostało zmienione.',
        linkMsg_: 'Zaloguj się',
      },
    },
    filtersComponentv2: {
      header_: 'Dodaj filtry',
      delete_: 'Usuń',
      search_: 'Szukaj',
      time_: 'Czas',
      height_: 'Wysokość',
      minHeight_: 'Wysokość min',
      maxHeight_: 'Wysokość max',
      status_operations_: 'Status operacji',
      status_missions_: 'Status misji',
      dtm_status_: 'Status',
      aglmax_: 'Agl max',
      icao_: 'ICAO',
      type_: 'Typ',
      heightUnit_: 'Jednostka wysokości',
      name_: 'Nazwa',
      calendar_: 'Przedział dniowy i czasowy',
    },
    controlPanel: {
      header_: 'Panel kontrolny',
      welcomeMessage_: 'Witaj',
      noShowFiltersText_:
        'Wybierz źródło w filtrach (z lewej strony mapy), żeby zobaczyć szczegóły',
      noData_: 'Brak danych',
      userOptionsMenu: {
        profile_: 'Profil',
        userSettings_: 'Ustawienia użytkownika',
        settings_: 'Ustawienia',
        admin_: 'Panel admina',
        contact_: 'Kontakt',
        areas_: 'Zarządzaj korytarzami',
        logout_: 'Wyloguj się',
      },
      menuButtons: {
        missions_: 'misje',
        operations_: 'operacje',
        zones_: 'strefy',
      },
    },
    startingMap: 'Wczytuje mapę...',
    approvedAreasDeatils: {
      chartTitle_: 'Wizualizacja korytarza',
      overSeaHeightLevel_: 'Wysokość n.p.m',
      approvedAreaLength_: 'Długość korytarza\n[km]',
      approvedAreaTopLevel_: 'Górna część korytarza',
      approvedAreaBottomLevel_: 'Dolna część korytarza',
      approvedAreaGroundLevel_: 'Linia ziemii',
      kilometerUnit_: 'km',
      meterUnit_: 'm',
      feetUnit_: 'ft.',
      resetZoomMessage: 'Reset zoom',
    },
    missionsDetails: {
      current_: 'Obecne',
      all_: 'Wszystkie',
      calendarHeader_: 'Wybierz przedział czasowy misji',
      calendarFromDate_: 'Od',
      calendarToDate_: 'Do',
      missonsHeader_: 'Misje',
      missionsListHeader_: 'Misje zaakceptowane w wybranym przedziale czasu',
      missionsListTimePeriodHeader: 'Obecnie trwające misje',
      calendarOk_: 'Zatwierdź',
      calendarCancel_: 'Anuluj',

      id_: 'Id misji',
      type_: 'Typ',
      status_: 'Status',
      startTime_: 'Czas rozpoczęcia',
      endTime_: 'Czas zakończenia',
      heightMax_: 'Wysokość max',
      heightMin_: 'Wysokość min',
      button_: 'Wybierz',
      callsign_: 'Callsign',
      pansaUid_: 'Pansa uid',
      approval_: 'Nr. pozwolenia',
      zoomIn_: 'Przybliż',
      details_: 'Szczegółowe informacje',
      rowsPerPage_: 'Liczba rekordów na stronie',
      observers_: 'Obserwatorzy',
      minimum_time_: 'Mimimalny czas',
      additional_time_: 'Dodatkowy czas',
      activityType_: 'Typ aktywności',
      ctrl_: 'Ctrl',
      description_: 'Opis',
      openOperation_: 'Podgląd Operacji',
      noOperationData_: 'Brak danych',
      gotoOperatiom_: 'Przejdź do Operacji',
      missionMsgModal: {
        message_: 'Wiadomość',
        browse_: 'Przeglądaj wiadomości',
        messageTime_: 'Godzina wysłania',
        contents_: 'Treść',
        sender_: 'Od',
        from_: 'z',
        openModal_: 'Otwórz konwersację',
      },
      noMissionsString_:
        'W podanym przedziale czasu nie zdefiniowano żadnej misji',
      alert: {
        noResult_: 'Brak wyników',
        timePerdioTooLarge_: 'Nie można pobrać okresu większego niż 31 dni',
        noFound_: 'Nie znaleziono zadnych wynikow w podanym przedziale czasu',
        startEndDate_:
          'Data zakończenia nie może być mniejsza od daty rozpoczęcia',
      },
      missionFiltersType: {
        status_: 'Status',
        type_: 'Typ',
        callsign_: 'Callsign',
        pansaUid_: 'Pansa uid',
        approval_: 'Approval',
        time_: 'Czas',
      },
    },
    defaultTimeZone: {
      header_: 'Strefa czasowa',
    },
    missionsApprovals: {
      header_: 'Misje oczekujące na akceptację',
      status_: 'Status',
      statusUtm_: 'Status w PANSA UTM',
      utmApprovalNr_: 'Numer zgody w PANSA UTM',
      start_: 'Start',
      stop_: 'Stop',
      type_: 'Typ misji',
      uid_: 'Id misji',
      name_: 'Nazwa',
      modified_: 'Data ostatniej modyfikacji misji',
      approve_: 'Zatwierdź',
      reject_: 'Odrzuć',
      decisionMessage_: 'Uzasadnienie decyzji',
      manageMission_: 'Zajmij się misją',
      cancel_: 'Anuluj',
      confirm_: 'Potwierdź',
      acceptance_: 'Zaakceptuj',
      rejection_: 'Odrzuć',
      approvalMsgLabel_: 'Dodatkowa wiadomość do decyzji',
      optional_: 'Opcjonalnie',
      required_: 'Wymagane',
      acceptedToday_: 'Zaakceptowane dzisiaj',
      rejectedToday_: 'Odrzucone dzisiaj',
      seeMore_: 'Zobacz więcej',
      minHeight_: 'Wysokość minimalna',
      maxHeight_: 'Wysokość maksymalna',
      startTime_: 'Początek misji',
      stopTime_: 'Koniec misji',
      geometry_: 'Geometria',
      desc_: 'Opis',
      extraInfo_: 'Dodatkowe informacje',
      numberOfLegs_: 'Liczba geometrii',
      zoom_: 'Przybliż',
    },
    operationsApprovals: {
      header_: 'Operacje oczekujące na akceptację',
      showLiveData_: 'Pokaż obiekty',
      status_: 'Status',
      statusUtm_: 'Status UTM',
      start_: 'Start',
      stop_: 'Stop',
      height_: 'Wysokość maksymalna',
      approve_: 'Zatwierdź',
      reject_: 'Odrzuć',
      cancel_: 'Anuluj',
      confirm_: 'Potwierdź',
      acceptance_: 'Zaakceptuj',
      rejection_: 'Odrzuć',
      empty_: 'Brak operacji do obsłużenia',
      openMission_: 'Pokaż Misje',
      missionDetails_: 'Szczegóły misji',
      noOperationData_: 'Brak danych. Wczytuje...',
      gotoOperatiom_: 'Przejdź do Misji',
      uid_: 'Id operacji',
      name_: 'Nazwa',
      lon_: 'Dlugość geograficzna',
      lat_: 'Szeokość geograficzna',
      pilot_: 'Numer pilota',
      operator_: 'Numer operatora',
      flightCategory_: 'Kategoria lotu',
      subcategory_: 'Podkategoria',
      weightClass_: 'Klasa wagowa',
      extraInfo_: 'Dodatkowe informacje',
    },
    confirmationModal: {
      approvalMsgLabel_: 'Dodatkowa wiadomość do decyzji',
      optional_: 'Opcjonalnie',
      required_: 'Wymagane',
      accept_: 'Akceptuj',
      reject_: 'Odrzuć',
      cancel_: 'Anuluj',
      text_: 'Jesteś pewny?',
    },
    filtersIcons: {
      uavos: 'Źródła',
      maps: 'Strefy',
      zone_categories: 'Kategorie stref',
      ruler: 'Linijka',
      roadMap: 'Mapy',
    },
    filtersMenuIcons: {
      source: 'Źródła',
      zones: 'Strefy',
      public: 'Infra',
      ruler: 'Linijka',
      map: 'Mapy',
    },
    zonesDetails: {
      infra_: 'Infrastruktura',
      categories: {
        other: 'Other',
        'Buildings-50m': 'Budynki-50m',
        'Buildings-25m': 'Budynki-25m',
        'Buildings-10m': 'Budynki-10m',
        'Buildings>50m': 'Budynki>50m',
        Prisons: 'Więzienia',
        'Power plants': 'Power plants',
        'Federal and state authorities': 'Budynki administracji',
        Embassies: 'Ambasada',
        Police: 'Policja',
        Hospitals: 'Szpital',
        Laboratories: 'Laboratorium',
        'Industrial sites': 'Tereny przemysłowe',
        Powerlines: 'Linie energetyczne',
        'Wind turbines': 'Turbiny wiatrowe',
        Stadiums: 'Stadiony',
        'Public parks': 'Parki publiczne',
        Bridges: 'Mosty',
        all: 'Wszystkie',
      },
      type_: 'Typ strefy',
      private_: 'Prywatne',
      public_: 'Publiczne',
      addZone_: 'Dodaj strefę',
      editZone_: 'Edytuj strefę',
      zonesListHeader_: 'Strefy',
      name_: 'Nazwa',
      uid_: 'Id',
      heightMax_: 'Wysokość max',
      heightMin_: 'Wysokość min',
      description_: 'Opis',
      restriction_: 'Restrykcje',
      noDescription_: 'Brak',
      startTime_: 'Start',
      stopTime_: 'Stop',
      button_: 'Wybierz',
      width_: 'Szerokość',
      edit_: 'Edytuj',
      govid_: 'GOV ID',
      created_: 'Utworzono',
      active_: 'Aktywna',
      heightRange_: 'Wybierz przedział wysokościowy',
      category_: 'Kategoria',
      allZones_: 'Wszystkie',
      zoom_: 'Przybliż',
      remove_: 'Usuń',
      noItems_: 'Nie wybrano żdnej strefy',
      basicInfo_: 'Podstawowe informacje',
      approvedDronesInfo_: 'Drony',
      activationsInfo_: 'Aktywacje',
      activations: {
        header_: 'Aktywacje',
        type_: 'Typ',
        temporary_: 'Tymczasowa',
        periodic_: 'Okresowa',
        pernament_: 'Stała',
        days: [
          '',
          'Poniedziałek',
          'Wtorek',
          'Środa',
          'Czwartek',
          'Piątek',
          'Sobota',
          'Niedziela',
        ],
        start_: 'Od [UTC]',
        stop_: 'Do [UTC]',
        days_: 'Dni',
        hours_: 'Godziny [UTC]',
        remove_: 'Usuń',
        noItems_: 'Brak aktywacji',
      },
      identifications: {
        id_: 'Id',
        remove_: 'Usuń',
        noItems_: 'Nie dodano zidentyfikowanych dronów',
      },
      addForm: {
        createZone_: 'Stwórz strefę',
        addActivationPeriod_: 'Dodaj okres aktywacji',
        addApprovedUavos_: 'Dodaj drony',
        addZoneFinished_: 'Koniec',
        activationForm: {
          chooseActivationType_: 'Wybierz typ aktywacji',
          temporaryInfo_: 'Wybierz w jakim okresie strefa będzie aktywna',
          periodicDayInfo_:
            'Wybierz w jakich dniach tygodnia strefa będzie aktywna',
          periodicHourInfo_: 'Wybierz w jakich godzinach strefa będzie aktywna',
          permanentInfo_:
            'Przy wyborze tej opcji strefa będzie aktywna cały czas',
          radioPeriodicLabel_: 'Okresowy',
          radioTemporaryLabel_: 'Czasowy',
          radioPermanentLabel_: 'Permanenty',
          saveButton_: 'Zapisz',
          skipButton_: 'Pomiń',
          further_: 'Dalej',
          activity_: 'Aktywność',
          errorTitle_: 'Błąd danych',
          errorSubtitle_: 'Nie możesz dodać okresów kolidujących ze sobą',
        },
        addApprovedDronesForm: {
          header_: 'Dodaj drony do strefy',
          icao_: 'ICAO',
          addButton_: 'Dodaj',
          presentDroneHeader_: 'Dron obecny w bazie',
          presentDroneHeaderSubtitle_:
            'Dron jest obecny w bazie, potwierdź, jeśli chcesz dodać poniższego drona do strefy.',
          cancel_: 'Anuluj',
          confirm_: 'Potwierdź',
          createdAt_: 'Data stworzenia',
          serialNumber_: 'Numery seryjny',
          danger_: 'Uwaga',
          dangerInfo_: 'Ten dron został już dodany do listy',
          noIdentificationDrones_: 'Ta strefa nie ma dodanych żadnych dronów.',
          forward_: 'Pomiń',
          back_: 'Cofnij',
          id_: 'ID',
          delete_: 'Usuń',
          error: 'Jeżeli chcesz dodać drona podaj jego ID',
        },
        finishedInfo: {
          in_: 'Za',
          secondPart_:
            'sekund zostaniesz przekierowany na stronę główną. Możesz kliknąć',
          button_: 'tutaj',
          lastPart_: 'jeśli chcesz przejść od razu.',
        },
      },
      editForm: {
        header_: 'Edytuj',
        textZone_: 'Strefy',
        textActivation_: 'Aktywacje',
        setType_: 'Ustawiono typ',
        tableId_: 'Id',
        tableFrom_: 'Od',
        tableTo_: 'Do',
        tableDel_: 'Usuń',
        addButton_: 'Dodaj',
        cancelButton_: 'Anuluj',
        editZone_: 'Edytuj strefę',
      },
      infoDetails: {
        temporary_: 'Czasowy',
        permanent_: 'Permanenty',
        periodic_: 'Okresowy',
        private_: 'Prywatna',
        public_: 'Publiczna',
        contact_: 'Kontakt',
        noActivation_: 'Brak aktywacji',
        type_: 'Typ',
        fullName_: 'Pełna nazwa',
        visibility_: 'Widoczność',
        activationType_: 'Typ aktywacji',
        activationFromTo_: 'Aktywacja',
        activationFrom_: 'od: ',
        activationTo_: 'do: ',
        activationDays_: 'Aktywacja w dni',
        activationHours_: 'Aktywacja w godziny',
        identification: {
          header_: 'Tabela identyfikacji dronów',
          list_icao: 'Numer ICAO/ID',
          list_approval: 'Typ zgody',
        },
      },
    },
    roadMap: {
      type_: 'Typ mapy',
      light: 'Jasna',
      outdoor: 'Plenerowa',
      dark: 'Ciemna',
      street: 'Klasyczna',
      satellite: 'Satelitarna',
      osm: 'Niebieska',
    },
    weather: {
      clear_sky_: 'Czyste niebo',
      few_clouds_: 'Kilka chmur',
      scattered_clouds_: 'Lekkie zachmurzenie',
      broken_clouds_: 'Duże zachmurzenie',
      shower_rain_: 'Przelotny deszcz',
      rain_: 'Deszcz',
      thunderstorm_: 'Burza',
      snow_: 'Opad śniegu',
      mist_: 'mgła',
      thunderstorm_with_light_rain_: 'Burza z lekkimi opadami',
      thunderstorm_with_rain_: 'Burza z opadami',
      thunderstorm_with_heavy_rain_: 'Burza z silnymi opadami',
      light_thunderstorm_: 'Lekka burza',
      heavy_thunderstorm_: 'Mocna burza',
      ragged_thunderstorm_: 'Nieregularna burza',
      thunderstorm_with_light_drizzle_: 'Burza z niewielką mżawką',
      thunderstorm_with_drizzle_: 'Burza z mżawką',
      thunderstorm_with_heavy_drizzle_: 'Burza z silną mżawką',
      light_intensity_drizzle_: 'Lekko natężona mżawka',
      drizzle_: 'Mżawka',
      heavy_intensity_drizzle_: 'Natężona mżawka',
      light_intensity_drizzle_rain_: 'Lekko natężona mżawka',
      drizzle_rain_: 'Mżawka',
      heavy_intensity_drizzle_rain_: 'Natężona mżawka',
      shower_rain_and_drizzle_: 'Przelotny deszcz i mżawka',
      heavy_shower_rain_and_drizzle_: 'Mocny przelotny deszcz i mżawka',
      shower_drizzle_: 'Krótka mżawka',
      light_rain_: 'Lekki deszcz',
      moderate_rain_: 'Umiarkowany opad deszczu',
      heavy_intensity_rain: 'Mocny i intensywny deszcz',
      very_heavy_rain: 'Bardzo mocny i intensywny deszcz',
      extreme_rain_: 'Ekstremalny deszcz',
      freezing_rain_: 'Zamarzający deszcz',
      light_intensity_shower_rain_: 'Mało intensywny przelotny deszcz',
      shower_rain: 'Przelotny deszcz',
      heavy_intensity_shower_rain: 'Itensywny przelotny deszcz',
      ragged_shower_rain_: 'Nierówny i przelotny deszcz',
      light_snow_: 'Lekki opad śniegu',
      heavy_snow_: 'Mocny opad śniegu',
      sleet_: 'Śnieg z deszczem',
      shower_sleet_: 'Przelotny śnieg z deszczem',
      light_shower_sleet: 'Lekki przelotny śnieg z deszczem',
      light_rain_and_snow: 'Lekki opad śniegu z deszczem',
      rain_and_snow_: 'Śnieg z deszczem',
      light_shower_snow_: 'Lekki przelotny opad śniegu',
      shower_snow_: 'Przelotny opad śniegu',
      heavy_shower_snow_: 'Silny, przelotny opad śniegu',
      smoke_: 'Dym',
      haze_: 'Mgła',
      sand_dust_whirls_: 'Wirujący pył piaskowy',
      fog_: 'Mgła',
      sand_: 'Piasek',
      dust_: 'Pył',
      volcanic_ash_: 'Pył wulkaniczny',
      squalls_: 'Szkwały',
      tornado_: 'Tornado',
      overcast_clouds_: 'Pełne zachmurzenie',
      legendBar: {
        temperature_: 'Temperatura',
        wind_: 'Prędkość wiatru, m/s',
        pressure_: 'Ciśnienie, hPa',
        clouds_: 'Zachmurzenie %',
      },
    },
    weekDays: {
      monday_: 'Poniedziałek',
      tuesday_: 'Wtorek',
      wednesday_: 'Środa',
      thursday_: 'Czwartek',
      friday_: 'Piątek',
      saturday_: 'Sobota',
      sunday_: 'Niedziela',
    },
    allOperationsTable: {
      tableColumns: {
        id_: 'Id',
        start_: 'Start',
        stop_: 'Stop',
        status_: 'Status',
        icao_: 'Icao',
        aglMax_: 'Wysokość AGL',
        zoomIn_: 'Przybliż',
      },
      filtersType: {
        status_: 'Status',
        icao_: 'Icao',
        heightAgl_: 'Wysokość AGL',
      },
    },
    uavoDetails: {
      id_: 'Id',
      type_: 'Typ',
      desc_: 'Opis',
      speed_: 'Prędkość',
      speedUnit_: 'km/h',
      altitude_: 'Pułap',
      altitudeUnit_: ' AMSL',
      lon_: 'Longitude',
      lat_: 'Latitude',
      track_: 'Azymut',
      sources_: 'Źródła',
      ids_: 'Ids',
      loadingWeather_: 'Pobieranie danych o pogodzie...',
      noWeatherData_: 'Brak danych o pogodzie.',
      heightUnit_: 'm AGL',
      weather_: 'Pogoda w: ',
      temperature_: 'Temperatura / odczuwalna ',
      wind_: 'Wiatr / kierunek',
      weatherCondition_: 'Warunki atmosferyczne',
      button_: 'Wybierz',
      follow_: 'Podążaj',
      zoom_: 'Przybliż',
      noItems_: 'Nie wybrano żadnego uav',
      windParser: {
        north_: 'N',
        northEast_: 'NE',
        east_: 'E',
        southEast_: 'SE',
        south_: 'S',
        southWest_: 'SW',
        west_: 'W',
        northWest_: 'NW',
      },
      aircrafts: {
        icao_: 'ICAO',
        baroAltitude_: 'Pułap barometryczny',
        verticalSpeed_: 'Prędkość wznoszenia/opadania',
        originCountry_: 'Kraj pochodzenia',
      },
    },
    operationsDetails: {
      current_: 'Obecne',
      allMissions_: 'Wszystkie',
      headerMessage_: 'Wybierz drona na mapie, aby wyświetlić szczegóły.',
      operationsListHeader_: 'Operacje',
      selectedUavosHeader_: 'Zaznaczone obiekty',
      operationDetails: {
        id_: 'Id',
        startTime_: 'Start',
        endTime_: 'Stop',
        phone_: 'Telefon',
        heightMax_: 'Wysokość max',
        heightMin_: 'Wysokość min',
        extraInfo_: 'Dodatkowe informacje',
        noExtraInfo_: 'Nie podano',
        button_: 'Wybierz',
      },
    },
    areas: {
      main: {
        header_: 'Zarządzaj lokalnymi strefami',
        button_: 'Nowy',
      },
      list: {
        header_: 'Lista stref lokalnych',
        name_: 'Nazwa',
        desc_: 'Opis',
        min_: 'Wysokość minimalna',
        max_: 'Wysokość maksymalna',
        width_: 'Szerokość',
        preview_: 'Edytuj',
        toolTipInfo_: 'Zmienia typ wykresu korytarza',
        labelInfoArea_: 'Wykres warstwowy',
        labelInfoStepped_: 'Wykres schodkowy',
        chartWarning_: 'Za mało danych aby wyświetlić wykres',
        notPolygon: 'Nie ma wykresu. Nie ma danych o wysokości',
        loading_: 'Wczytuje lokalne strefy...',
        noAreas_: 'Nie ma stworzonych korytarzy.',
        deleteForm: {
          confirmButton_: 'Usuń',
          cancelButton_: 'Cofnij',
          confirmationText_: 'Czy napewno chcesz usunąć wybrany element?',
          areaNameText_: 'Nazwa strefy',
        },
      },
      add: {
        header_: 'Stwórz korytarz powietrzny',
        formFields: {
          name_: 'Nazwa',
          desc_: 'Opis',
          min_: 'Minimalna wysokość',
          max_: 'Maksymalna wysokość',
          width_: 'Szerokość',
          type_: 'Źródło danych',
          button_: 'Zapisz',
          visibility_: 'Widoczność',
          private_: 'Prywatna',
          public_: 'Publiczna',
          zoneType_: 'Typ',
          contact_: 'Kontakt',
          zoneCategory_: 'Kategoria strefy',
        },
        map: {
          height_: 'Wysokość',
          width_: 'Szerokość',
          line_: 'Wyznacz strefę',
          clear_: 'Wyczyść',
          selectFile_: 'Wybierz plik',
          fileFormat_: 'Wybierz plik .kml z geometrią lini',
        },
      },
      edit: {
        header_: 'Edytuj korytarz powietrzny',
        formFields: {
          name_: 'Nazwa',
          desc_: 'Opis',
          min_: 'Wysokość minimalna',
          max_: 'Wysokość maksymalna',
          width_: 'Szerokość',
          type_: 'Źródło danych',
          button_: 'Zapisz',
          editToggleButton_: 'Edytuj',
          visibility_: 'Widoczność',
          private_: 'Prywatna',
          public_: 'Publiczna',
          zoneType_: 'Typ',
          contact_: 'Kontakt',
          click_: 'Kliknijj',
          here_: 'tutaj',
          restInfo_: 'aby dodać drony do strefy',
        },
      },
      placeholderForm: {
        required: 'To pole jest wymagane',
        text: ', min. 3 znaki, max. 50 znaków',
        description: ', min. 3 znaki, max. 250 znaków',
        email: ', w formacie: jan.kowalski@hawk-e.com.pl',
        number: ', podaj tylko liczby',
        phone: ', podaj poprawny numer telefonu',
        phonePattern: 'Kontakt telefoniczny, w formacie: XXX XXX XXX',
        nameExsits_: ', nazwa nie może się powtarzać',
      },
    },
    approvedAreasDetails: {
      headerMessage_:
        'Kliknij korytarz na mapie, aby wyświetlić o nim informacje.',
      listHeader_: 'Szczegóły zaznaczonych korytarzy',
      approvedAreasDetails_: 'Korytarze',
      name_: 'Nazwa',
      desc_: 'Opis',
      min_: 'Wysokość minimalna',
      max_: 'Wysokość maksymalna',
      width_: 'Szerokość',
      editHeader_: 'Zarządzaj lokalnymi strefami',
      editButton_: 'Edytuj korytarz powietrzny',
    },
    userSettings: {
      userSettings_: 'Ustawienia użytkownika',
      profileSettings_: 'Ustawienia profilu',
      dashboardSettings_: `Konfiguracja dashboard'u`,
      mainSettings: {
        defaultLanguage_: 'Język',
        defaultTheme_: 'Szablon',
        defaultFontSize_: 'Wielkość czcionki',
        defaultThemeOptions: {
          light: {
            key_: 'Jasny',
            value_: 'light',
          },
          dark: {
            key_: 'Ciemny',
            value_: 'dark',
          },
        },
        defaultFontSizeOptions: {
          small: {
            key_: 'Mała',
            value_: 0.6,
          },
          normal: {
            key_: 'Normalna',
            value_: 0.7,
          },
          large: {
            key_: 'Wielka',
            value_: 1,
          },
        },

        language: {
          en_: 'Angielski',
          pl_: 'Polski',
        },
      },
    },
    filters: {
      ruler: {
        start: 'Kliknij w mapę aby rozpocząć zmierzenie odległośći.',
        mouseButton: 'Dwukrotne kliknęcie',
        stop: ' na mapę zakończy działanie.',
      },
      popup: {
        distance: 'Odległość',
        changeDistance: 'Zmień skalę',
      },
      uavos: {
        type_: 'Source type',
        noData_: 'Brak danych',
        header_: 'Wybierz źródła',
        drones_: 'Drony',
        aircrafts_: 'Samoloty',
      },
    },
    userProfile: {
      header_: 'Edytuj swoje dane:',
      button_: 'Zapisz',
      title_: 'Twój profil',
      formFields: {
        firstName_: 'Imię',
        lastName_: 'Nazwisko',
        username_: 'Nazwa użytkownika',
        email_: 'Email',
        phone_: 'Numer telefonu',
        password_: 'Hasło',
        rePassword_: 'Powtórz hasło',
        city_: 'Miasto',
        street_: 'Ulica',
        number_: 'Numer',
      },
    },
    adminZone: {
      header_: 'Witaj w panelu administratora',
      menuOptions: {
        first_: 'Organizacje',
        second_: 'Użytkownicy',
        third_: 'Zarządzaj uprawnieniami',
        four_: 'Zarządzaj korytarzami',
        fifth_: 'Ustawienia systemu',
      },
      addOrganization: {
        header_: 'Dodaj organizację',
        formFields: {
          drawOrg_: 'Wybierz plik lub wyznacz granice organizacji na mapie: ',
          name_: 'Nazwa organizacji',
          phone_: 'Telefon',
          city_: 'Miasto',
          street_: 'Ulica',
          number_: 'Numer budynku',
          email_: 'Adres email',
          nip_: 'Numer NIP',
          regon_: 'Numer REGON',
          buffer_: 'Bufor jurysdykcji',
          addButton_: 'Dodaj',
          editButton_: 'Edytuj',
          button_: 'Zapisz',
          deleteButton_: 'Usuń',
          editInform_: 'Jesteś w trybie edycji',
        },
        selectedOrgTitle_: 'Wybrałeś organizację nadrzędną',
        notSelectedOrgTitle_: 'Tworzysz organizację nadrzędną',
        existingOrgs: {
          orgTitle_: 'Organizacja',
          city_: 'Miasto',
          street_: 'Ulica',
          number_: 'Numer lokalu',
          phone_: 'Telefon',
          expandTitleSlaves_: 'Wyświetl organizacje podrzędne',
          slaveOrgTitle_: 'Organizacja podrzędna',
          button_: 'Wybierz',
          addExistingOrganization_: 'Kliknij aby dodać organizację podrzędną',
        },
        iconsLabels: {
          polygon_: 'Zaznacza obszar',
          line_: 'Rysuje linie',
          point_: 'Zaznacza punkt',
          circle_: 'Rysuje okrąg',
          clear_: 'Usuń',
          zoneHeight_: 'Zdefiniuj wysokość strefy',
          selectFile_: 'Wybierz plik',
          fileFormat_: 'Obsługiwane pliki .kml',
        },
        preview_: 'Podgląd',
      },
      editOrganization: {
        header_: 'Podgląd organizację',
        formFields: {
          drawOrg_: 'Wybierz plik lub wyznacz granice organizacji na mapie: ',
          name_: 'Nazwa organizacji',
          phone_: 'Telefon',
          city_: 'Miasto',
          street_: 'Ulica',
          number_: 'Numer budynku',
          email_: 'Adres email',
          nip_: 'Numer NIP',
          regon_: 'Numer REGON',
          buffer_: 'Bufor jurysdykcji',
          button_: 'Zapisz',
          addButton_: 'Dodaj',
          editButton_: 'Edytuj',
          cancelEditButton_: 'Anuluj',
          deleteButton_: 'Usuń',
          editInform_: 'Jesteś w trybie edycji',
        },
        iconsLabels: {
          polygon_: 'Zaznacza obszar',
          line_: 'Rysuje linie',
          point_: 'Zaznacza punkt',
          circle_: 'Rysuje okrąg',
          clear_: 'Usuń',
          zoneHeight_: 'Zdefiniuj wysokość strefy',
          selectFile_: 'Wybierz plik',
          fileFormat_: 'Obsługiwane pliki .kml',
        },
        selectedOrgTitle_: 'Edytujesz organizację',
      },
      userList: {
        header_: 'Użytkownicy',
        belongingOrganization_: 'Organizacja należąca',
        preview_: 'Podgląd',
        active_: 'Aktywny',
        inactive_: 'Zablokowany',
        user_: 'Użytkownik',
        address_: 'Adres',
        phoneNumber_: 'Tel.',
        mail_: 'e-mail',
        organization_: 'Organizacja',
        loginInfo: {
          seen_: 'Ostatnio widziany',
          notSeen_: 'Nigdy się nie zalogował',
        },
        organizationData_: 'Nie pobrało danych',
      },
      user: {
        addUserButton_: 'Dodaj',
        editUserButton_: 'Zapisz',
        activeUsers: 'Aktywni',
        inactiveUsers: 'Nieaktywni',
        header_: 'Edytuj użytkownika',
        button_: 'Zapisz',
        formFields: {
          firstName_: 'Imię',
          lastName_: 'Nazwisko',
          username_: 'Nazwa użytkownika',
          email_: 'Email',
          phone_: 'Numer telefonu',
          password_: 'Hasło',
          rePassword_: 'Powtórz hasło',
          city_: 'Miasto',
          street_: 'Ulica',
          number_: 'Numer',
          organization_: 'Wybierz organizację dla użytkownika',
          userGroups_: 'Przypisz grupę uprawnień użytkownikowi',
          checkBoxGroupInfo_: 'Wybierz co najmniej jedną',
        },
        addUser: {
          header_: 'Dodaj nowego użytkownika',
          noUsers_: 'Nie dodano jeszcze żadnych użytkowników',
          button_: 'Dodaj',
          formFields: {
            firstName_: 'Imię',
            lastName_: 'Nazwisko',
            username_: 'Nazwa użytkownika',
            email_: 'Email',
            phone_: 'Numer telefonu',
            password_: 'Hasło',
            rePassword_: 'Powtórz hasło',
            city_: 'Miasto',
            street_: 'Ulica',
            number_: 'Numer',
            organization_: 'Wybierz organizację dla użytkownika',
            userGroups_: 'Przypisz grupę uprawnień użytkownikowi',
            checkBoxGroupInfo_: 'Wybierz co najmniej jedną',
          },
        },
      },
      permissions: {
        header_: 'Zarządzaj uprawnieniami',
        manageUserPermission: {
          admin_: 'Nadaj użytkownikowi uprawnienia administratora',
          active_: 'Zablokuj użytkownika',
          email_: 'Zweryfikuj ręcznie adres email',
          phone_: 'Zweryfikuj ręcznie telefon kontaktowy',
          subTitle_: 'Edytujesz uprawnienia użytkownika',
        },
      },
      systemSettings: {
        header_: 'Ustawienia systemu',
        buttonText_: 'Zapisz',
        drones_service_: 'Serwis dronów',
        ogn_: 'OGN',
        common: {
          add_topic_: 'Dodaj temat',
          area_: 'Obszar',
          common_: 'Wspólne ustawienia',
          mqtt_pass_: 'Hasło użytkownika mqtt',
          mqtt_port_: 'Port serwera mqtt',
          mqtt_server_: 'Adres serwera Mqtt',
          mqtt_user_: 'Nazwa użytkownika mqtt',
          no_data_: 'Brak danych do wyświetlenia',
          password_: 'Hasło',
          port_: 'Port',
          redis_: 'Serwer redis (pojazdy inne niż drony)',
          redis_cache_: 'Serwer redis_cache (pojazdy inne niż drony)',
          redis_drone_: 'Serwer redis_drone',
          redis_drone_cache_: 'Serwer redis_drone_cache',
          redis_drone_main_: 'Serwer redis_drone_main',
          redis_exp_: 'Czas trzymania danych w redisie',
          redis_main_: 'Serwer redis_main (pojazdy inne niż drony)',
          redis_port_: 'Port, na którym działają redisy',
          source_url_: 'Adres źródła',
          srtm_server_: 'Adres serwera SRTM',
          topics_: 'Tematy do subskrybowania',
          user_: 'Nazwa użytkownika',
        },
        hertz: {
          header_: 'Hertz System',
          topicsIn_: 'Nazwy tematów dla danych przychodzących',
          topicOut_: 'Nazwa tematu dla danych wychodzących',
          stationBuffer_: 'Promień bufora stacji Hertz',
        },
        aps: {
          aps_: 'APS',
          radars_: 'Adresy radarów',
          dtm_uavos_url_: 'Endpoint zapisywania dronów w DTM',
          add_topic_: 'Dodaj kolejne źródło',
        },
        aerobits: {
          aerobits_: 'Aerobits',
          add_topic_: 'Dodaj kolejny topik',
        },
        atam: {
          atam_: 'ATAM',
          interval_drones_: 'Interwał dla dronów',
          interval_uavos_: 'Interwał dla uavo',
          iff_enabled_: 'Moduł IFF włączony',
        },
        drones_service: {
          drones_service_: 'Serwis dronów',
          add_topic_: 'Dodaj topic',
        },
        open_sky: {
          open_sky_: 'Open Sky',
          area_: 'Obszar',
          os_user_: 'Nazwa użytkownika',
          os_pass_: 'Hasło',
          os_url_: 'Adres źródła',
        },
        ufs: {
          ufs_: 'UFS',
          interval_: 'Interwał w sekundach',
          lon_buffer_: 'Bufor długości geograficznej w metrach',
          lat_buffer_: 'Bufor szerokości geograficznej w metrach',
          height_buffer_: 'Bufor wysokości w metrach',
          azimuth_buffer_: 'Bufor azymutu w stopniach',
        },
        utm: {
          utm_: 'UTM',
          utm_exp_: 'Czas trzymania danych w redisie',
          dtm_operations_url_: 'Adres w systemie DTM',
          utm_operations_url_: 'Adres źródła',
        },
        core: {
          core_: 'Core',
          zones_url_: 'Adres stref z systemu UTM',
          zones_types_url_: 'Adres typów stref z systemu UTM',
          ogn_models_: 'Adres bazy pojazdów OGN',
          open_sky_db_: 'Adres bazy pojazdów Open Sky',
          open_sky_types_: 'Adres bazy typów pojazdów Open Sky',
          missions_url_: 'Adres misji z systemu UTM',
          weather_url_: 'Adres serwisu pogodowego',
          weather_api_: 'Klucz do API serwisu pogodowego',
          email_use_ssl_: 'Używaj SSL',
          email_host_: 'Adres serwera email',
          email_port_: 'Port serwera email',
          email_host_user_: 'Nazwa użytkownika email',
          email_host_password_: 'Hasło użytkownika email',
          default_from_email_: 'Adres, który pojawia się w polu "od"',
        },
        editSettings: {
          save_: 'Zapisz',
        },
      },
      subscriptions: {
        header_: 'Subskrypcje',
        noSubscriptions_: 'Brak subskrypcji',
        id_: 'ID',
        created_: 'Data utworzenia',
        start_: 'Początek subskrypcji',
        stop_: 'Koniec subskrypcji',
        active_: 'Status',
        organization_: 'Organizacja',
        payments: {
          header_: 'Płatności',
          created_: 'Data utworzenia',
          invoice_number_: 'Numer rachunku',
          payment_till_: 'Płatność do ',
          payment_booked: 'Data księgowania',
          discount_: 'Zniżka',
        },
        add_: 'Dodaj subskrypcję',
        form: {
          organization_: 'Wybierz organizację',
          plan_: 'Wybierz plan subskrybcji',
          dates_: 'Początek i koniec subskrypcji',
          planCategory_: 'Kategoria planu',
          planType_: 'Typ płatności',
          planCost_: 'Koszt',
          planDesc_: 'Opis planu',
        },
      },
    },
    dashboardConfig: {
      title_: 'Konfiguracja dashboardu',
      zones: {
        title_: 'Zarządzanie typami stref',
        approvedAreas_: 'Korytarze',
        noData_: 'Brak typów stref',
      },
      uavos: {
        title_: 'Zarządzaj źródłami',
        all_: 'Wszystkie',
        simulator_: 'Symulator',
        utm_: 'UTM',
        aircrafts_: 'Samoloty',
      },
    },
    contactModule: {
      header_: 'Kontakt',
      subHeader_: 'Napisz do nas',
      formFields: {
        topic_: 'Sprecyzuj powód kontaktu',
        desc_: 'Opisz sprawę w jakiej się kontaktujesz',
        button_: 'Wyślij',
      },
    },
    alerts: {
      loginError: {
        title_: 'Błąd logowania',
        desc_: 'Nie udało się zalogować używjąc podanych danych logowania.',
      },
      loginSuccess: {
        title_: 'Poprawnie zalogowano!',
        desc_: 'Zostałeś poprawnie zalogowany.',
      },
      requestError: {
        title_: 'Błąd pobierania danych',
        desc_: 'Nie udało się pobrać danych ',
      },
      dataProccessError: {
        title_: 'Błąd przetwarzania danych',
        desc_: 'Podczas przetwarzania danych wystąpił błąd',
      },
      sendingEmailError: {
        errorDesc_: 'Ten email nie istnieje',
        msgDesc_: 'Bład 400: Serwer nie był w stanie przetworzyć żądania',
      },
      addDataSuccess: {
        title_: 'Sukces',
        desc_: 'Pomyślnie zapisano dane',
      },
      requestWarning: {
        title_: 'Nie znaleziono',
        desc_: 'Nie udało się odnaleźć żadnych danych o podanych kryteriach',
      },
      noResults: {
        title_: 'Brak wyników',
        desc_: 'Nie znaleziono wyników w podanym przedziale',
      },
      noUsersAlert: 'Nie dodano jeszcze żadnego użytkownika.',
      weatherFail: {
        title_: 'Brak wyników',
        desc_: 'Nie można pobrać pogody dla tego miejsca',
      },
      mapInfoTooLargeDashboard: {
        title_: 'Mapa za duża',
        desc_: 'Mapa nie może zajmować więcej niż cały ekran.',
      },
      mapInfoTooLarge: {
        title_: 'Mapa za duża',
        desc_: 'Mapa nie może zajmować więcej niż 60% strony.',
      },
      mapInfoTooSmallDashboard: {
        title_: 'Mapa zbyt mała',
        desc_: 'Mapa nie może być mniejsza niż 30% strony.',
      },
      mapInfoTooSmall: {
        title_: 'Mapa zbyt mała',
        desc_: 'Mapa nie może być mniejsza niż 30% strony.',
      },
      deleteSuccess: {
        title_: 'Skasowano!',
        desc_: 'Poprawnie usunięto element',
      },
      deleteError: {
        title_: 'Błąd',
        desc_: 'Nie udało się poprawnie skasować elementu.',
      },
      1: {
        title_: 'Niepoprawne dane',
        desc_: 'Wysłane dane są niepoprawne.',
      },
      2: {
        title_: 'Niepoprawna geometria',
        desc_: 'Podana geometria jest poza geometrią rodzica.',
      },
      3: {
        title_: 'Błąd email',
        desc_: 'Serwis napotkał błąd w wysłaniu e-maila.',
      },
      4: {
        title_: 'Błąd email',
        desc_: 'Podany email nie istnieje.',
      },
      5: {
        title_: 'Niepoprawna geometria',
        desc_: `Podana geometria jest poza geometrią organizacji.`,
      },
      6: {
        title_: 'Niepoptrawna geometria',
        desc_: `Podana geometria jest błędna.`,
      },
      7: {
        title_: 'Błąd',
        desc_: `Coś złego stało się po stronie serwera.`,
      },
      8: {
        title_: 'Token',
        desc_: `Token jest nieważny`,
      },
      9: {
        title_: 'Niautoryzwane',
        desc_: `Działanie jest nieautoryzowane.`,
      },
      200: {
        title_: 'Sukces',
        desc_: 'Pomyślnie zapisano dane',
      },
      400: {
        title_: 'Nieprawidłowe żądanie',
        desc_: `Działanie jest nieautoryzowane.`,
      },

      screenResolution: {
        desc1_: 'Rozdzielczość Twojego ekranu to ',
        desc2_: `pikseli i${'\u00A0'}system może nie działać zgodnie z${'\u00A0'}oczekiwaniami.\nEkran powinien mieć co${'\u00A0'}najmniej `,
        desc3_: `pikseli szerokości i${'\u00A0'}co${'\u00A0'}najmniej `,
        desc4_: 'pikseli wysokości.',
      },
      fileExport: {
        title_: 'Eksport pliku',
        desc_: 'Plik został wyeksportowany pomyślnie.',
      },
    },
    map: {
      tileConfigurator: {
        removeWeatherLayer_: 'Ukryj mapy pogodowe',
        expandMaps_: 'Mapy pogodowe',
        hideMaps: 'Zwiń',
        temperature_: 'Mapa temperaturowa',
        pressure_: 'Mapa ciśnienia',
        wind_: 'Mapa wiatru',
        clouds_: 'Mapa zachmurzenia',
        precipitation_: 'Mapa opadów',
      },
      resizer: {
        greatenMap_: 'Powiększ mapę',
        reduceMap_: 'Pomniejsz mapę',
        centerMap_: 'Wyśrodkuj mapę',
      },
    },
    drawMap: {
      tooltip_: 'Pokaż obiekty na mapie',
    },
    errors: {
      required: 'Pole wymagane',
      onlyNumbersAndLetters_: 'To pole może zawierać tylko litery oraz liczby.',
      passwordRequirements_:
        'Hasło powinno zawierać: wielką literę, numer, znak specjalny, długość od 8 do 40 znaków',
      phoneRequirements_:
        'Numer telefonu może zaczynać się od +48/00, ale może również bez numeru kierunkowego, długość od 7 do 32 znaków.',
    },
    tables: {
      expression_: ' z ',
      moreThen_: ' powyżej ',
    },
    utcInfo_: 'Edytujesz w systemie czasowym UTC.',
    userPermissionList: {
      org_admin_: 'Admin organizacji / Menadżer',
      controller_: 'Kontroler',
      reader_: 'Oglądający',
      reporter_: 'Reporter',
    },
    exportButton: {
      fetchingDataInfo_: 'Pobieranie danych...',
      export_: 'Eksportuj',
      fileTypeInfo_: 'Wybierz rozszerzenie pliku',
      cancel_: 'Anuluj',
    },
  },
  en: {
    appName_: 'Zodiac',
    back_: 'Back',
    close_: 'Close',
    loginScreen: {
      username_: 'User Name',
      password_: 'Password',
      helloMessage_: 'Welcome',
      message_: 'Log in:',
      forgotPassword_: 'Forgot password?',
      noAccountMessage_: 'Dont have account yet? Sign up!',
      button_: 'Log in!',
      rememberMe_: 'Remember me',
    },
    loader_:
      'Think there is a problem with the server. Trying to reconnect ...',
    loaderError_: 'Unable to receive data',
    requiredField: '* - this field is required',
    sidebar: {
      dashboard_: 'Dashboard',
      admin_: 'Admin',
      settings_: 'Settings',
      uspace_: 'History',
      airspace_: 'Air Space',
      profile_: 'Profile',
      uspace: {
        operations_: 'Operations',
        missions_: 'Missions',
      },
      airspace: {
        zones_: 'Zones',
        corridors_: 'Airways',
      },
      settings: {
        userSettings_: 'User Settings',
        dashboardSettings_: 'Dashboard Configuration',
        profileSettings_: 'Profile settings',
        contact_: 'Contact',
        logout_: 'Logout',
      },
      admin: {
        organizations_: 'Organizations',
        users_: 'Users',
        subscriptions_: 'Subscriptions',
        systemSettings_: 'System settings',
      },
      operations_: 'Operations',
      zones_: 'Zones',
      missions_: 'Missions',
      approvedAreas_: 'Airways',
      adminZone_: 'Administrator panel',
      heightUnit_: 'Height unit',
    },
    resetPassword: {
      emailPage: {
        header_:
          'Enter your email address and we send you message with link to change your password',
        email_: 'Email',
        button_: 'Send',
        sending_: 'Sending ',
        successMsg_: 'Message was sent. Check your mail box',
        backMsg_: 'Back to the login page',
        resetPassword_: 'Reset password',
        confirmMsg_: 'Do you want to reset password?',
        cancel_: 'Cancel',
        faildMsg_: 'Something went wrong. Try again',
        close_: 'Close',
      },
      setPassword: {
        header_: 'Set your a new password and confirm it',
        password_: 'New password',
        rePassword_: 'Repeat password',
        button_: 'Save',
        successMsg_: 'Password was changed',
        linkMsg_: 'Log in',
      },
    },
    controlPanel: {
      header_: 'Control panel',
      welcomeMessage_: 'Welcome',
      noShowFiltersText_:
        'Select a source in filters (on the left side of the map) to see details',
      noData_: 'No data',
      menuButtons: {
        missions_: 'missions',
        operations_: 'operations',
        zones_: 'zones',
      },
      userOptionsMenu: {
        profile_: 'Profile',
        userSettings_: 'User settings',
        settings_: 'Settings',
        admin_: 'Admin zone',
        contact_: 'Contact',
        areas_: 'Approved areas',
        logout_: 'Log out',
      },
    },
    startingMap: 'Loading map...',
    approvedAreasDeatils: {
      chartTitle_: 'Airway visualisation',
      overSeaHeightLevel_: 'Height AMSL',
      approvedAreaLength_: 'Approved area length',
      approvedAreaTopLevel_: 'Top level of approved area',
      approvedAreaBottomLevel_: 'Bottom level of approved area',
      approvedAreaGroundLevel_: 'Ground height',
      kilometerUnit_: 'km',
      meterUnit_: 'm',
      feetUnit_: 'ft.',
      resetZoomMessage: 'Reset zoom',
    },
    missionsDetails: {
      current_: 'Current',
      all_: 'All',
      calendarHeader_: 'Select time period for missions',
      calendarFromDate_: 'From',
      calendarToDate_: 'To',
      missonsHeader_: 'Missions',
      missionsListHeader_: 'Accepted missions in selected period',
      missionsListTimePeriodHeader: 'Currently ongoing missions',
      calendarOk_: 'OK',
      calendarCancel_: 'Cancel',
      id_: 'Mission Id',
      type_: 'Type',
      status_: 'Status',
      startTime_: 'Start time',
      endTime_: 'End time',
      heightMax_: 'Height max',
      heightMin_: 'Height min',
      button_: 'Select',
      callsign_: 'Callsign',
      pansaUid_: 'Pansa uid',
      approval_: 'Approval number',
      zoomIn_: 'Zoom in',
      details_: 'Details',
      rowsPerPage_: 'Rows per page',
      observers_: 'Observers',
      minimum_time_: 'Minimum time',
      additional_time_: 'Additional time',
      activityType_: 'Activity Type',
      ctrl_: 'Ctrl',
      description_: 'Description',
      openOperation_: 'View Operation',
      gotoOperatiom_: 'Go to Operation',
      noOperationData_: 'No data yet. Loading...',
      missionMsgModal: {
        message_: 'Message',
        browse_: 'Browse messages',
        messageTime_: 'Send at',
        contents_: 'Content',
        sender_: 'From',
        from_: 'from',
        openModal_: 'Conversation',
      },
      noMissionsString_: 'In given period there are no defined missions',
      alert: {
        noResult_: 'No results',
        timePerdioTooLarge_:
          'You can not check larger period of time than 31 days',
        noFound_: 'In given period there are no records',
        startEndDate_: 'End date could not be greater than start date',
      },
      missionFiltersType: {
        status_: 'Status',
        type_: 'Type',
        callsign_: 'Callsign',
        pansaUid_: 'Pansa uid',
        approval_: 'Approval',
        time_: 'Time',
      },
    },
    defaultTimeZone: {
      header_: 'Time zone',
    },
    missionsApprovals: {
      header_: 'Waiting missions',
      status_: 'Status',
      statusUtm_: 'PANSA UTM status',
      utmApprovalNr_: 'PANSA UTM approval number',
      start_: 'Start',
      stop_: 'Stop',
      type_: 'Mission type',
      uid_: 'Mission Id',
      name_: 'Name',
      cancel_: 'Cancel',
      modified_: 'Last modification',
      approve_: 'Accept',
      approvalMsgLabel_: 'Additional message',
      optional_: 'Optional',
      required_: 'Required',
      reject_: 'Reject',
      acceptance_: 'Accept',
      rejection_: 'Reject',
      decisionMessage_: 'Reason of decision',
      acceptedToday_: 'Accepted today',
      rejectedToday_: 'Rejected today',
      minHeight_: 'Minimal height',
      maxHeight_: 'Maximal height',
      startTime_: 'Start time',
      stopTime_: 'Stop time',
      geometry_: 'Geometry',
      desc_: 'Description',
      extraInfo_: 'Extra info',
      numberOfLegs_: 'Geometries parts',
      zoom_: 'Zoom in',
    },
    operationsApprovals: {
      header_: 'Operations to accept',
      showLiveData_: 'Show flying objects',
      statusUtm_: 'UTM Status',
      status_: 'Status',
      start_: 'Start',
      stop_: 'Stop',
      height_: 'Height max',
      approve_: 'Accept',
      reject_: 'Reject',
      cancel_: 'Cancel',
      confirm_: 'Confirm',
      acceptance_: 'Accept',
      rejection_: 'Reject',
      empty_: 'No operations to handle',
      openMission_: 'View Mission',
      missionDetails_: 'Mission details',
      noOperationData_: 'No data',
      gotoOperatiom_: 'Go to Mission',
      uid_: 'Operation Id',
      name_: 'Name',
      zoom_: 'Zoom in',
      lon_: 'Longitude',
      lat_: 'Latitude',
      pilot_: 'Pilot number',
      operator_: 'Operator number',
      flightCategory_: 'Flight category',
      subcategory_: 'Subcategory',
      weightClass_: 'Weight class',
      extraInfo_: 'Extra info',
    },
    confirmationModal: {
      approvalMsgLabel_: 'Additional message',
      optional_: 'Optional',
      required_: 'Required',
      accept_: 'Accept',
      reject_: 'Reject',
      cancel_: 'Cancel',
      text_: 'Are you sure?',
    },
    filtersComponentv2: {
      header_: 'Add filtres',
      delete_: 'Delete',
      search_: 'Search',
      time_: 'Time',
      height_: 'Height',
      minHeight_: 'Min height',
      maxHeight_: 'Max height',
      status_operations_: 'Operation status',
      status_missions_: 'Mission status',
      dtm_status_: 'Status',
      aglmax_: 'Agl max',
      icao_: 'ICAO',
      type_: 'Type',
      heightUnit_: 'Height unit',
      name_: 'Name',
      calendar_: 'Date & time period',
    },
    filtersIcons: {
      uavos: 'Sources',
      maps: 'Zones',
      zone_categories: 'Zone categories',
      ruler: 'Ruler',
      roadMap: 'Maps',
    },
    filtersMenuIcons: {
      source: 'Sources',
      zones: 'Zones',
      public: 'Infra',
      ruler: 'Ruler',
      map: 'Maps',
    },
    zonesDetails: {
      infra_: 'Infrastructure',
      categories: {
        other: 'Other',
        'Buildings-10m': 'Buildings-10m',
        'Buildings-25m': 'Buildings-25m',
        'Buildings-50m': 'Buildings-50m',
        'Buildings>50m': 'Buildings>50m',
        Prisons: 'Prisons',
        'Power plants': 'Power plants',
        'Federal and state authorities': 'Federal and state authorities',
        Embassies: 'Embassies',
        Police: 'Police',
        Hospitals: 'Hospitals',
        Laboratories: 'Laboratories',
        'Industrial sites': 'Industrial sites',
        Powerlines: 'Powerlines',
        'Wind turbines': 'Wind turbines',
        Stadiums: 'Stadiums',
        'Public parks': 'Public parks',
        Bridges: 'Bridges',
        all: 'All',
      },
      type_: 'Zone type',
      private_: 'Private',
      public_: 'Public',
      addZone_: 'Add zone',
      editZone_: 'Edit zone',
      zonesListHeader_: 'Zones',
      name_: 'Name',
      uid_: 'Id',
      heightMax_: 'Height max',
      heightMin_: 'Height min',
      description_: 'Description',
      restriction_: 'Restriction',
      noDescription_: 'Not given',
      startTime_: 'Start',
      stopTime_: 'Stop',
      button_: 'Select',
      width_: 'Width',
      edit_: 'Edit',
      govid_: 'GOV ID',
      created_: 'Created',
      active_: 'Active',
      heightRange_: 'Pick height range',
      category_: 'Category',
      contact_: 'Contact',
      visibilityType_: 'Visibility type',
      activityType_: 'Active',
      activeYes_: 'Yes',
      activeNo_: 'No',
      zoom_: 'Zoom',
      remove_: 'Remove',
      noItems_: 'No zones selected',
      basicInfo_: 'Basic informations',
      approvedDronesInfo_: 'Drones',
      activationsInfo_: 'Activations',
      activations: {
        header_: 'Activations',
        type_: 'Type',
        temporary_: 'Temporary',
        periodic_: 'Periodic',
        pernament_: 'Pernament',
        days: [
          '',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        start_: 'From [UTC]',
        stop_: 'To [UTC]',
        days_: 'Days',
        hours_: 'Hours [UTC]',
        remove_: 'Remove',
        noItems_: 'No activations',
      },
      identifications: {
        id_: 'Id',
        remove_: 'Remove',
        noItems_: 'No drones identifications added',
      },
      addForm: {
        createZone_: 'Create zone',
        addActivationPeriod_: 'Add activation period',
        addApprovedUavos_: 'Add drones',
        addZoneFinished_: 'Finished',
        activationForm: {
          chooseActivationType_: 'Choose activation type',
          temporaryInfo_: 'Choose time range where area will be active',
          periodicDayInfo_: 'Select the days on which the zone will be active',
          periodicHourInfo_: 'Select at what times the zone will be active.',
          permanentInfo_:
            'With this option selected, the zone will be active all the time',
          radioPeriodicLabel_: 'Periodic',
          radioTemporaryLabel_: 'Temporary',
          radioPermanentLabel_: 'Permanent',
          saveButton_: 'Save',
          skipButton_: 'Skip',
          further_: 'Done',
          activity_: 'Activity',
          errorTitle_: 'Data error',
          errorSubtitle_: 'You can not add overlaying time periods.',
        },
        addApprovedDronesForm: {
          header_: 'Add drones to the zone',
          icao_: 'ICAO',
          addButton_: 'Add',
          presentDroneHeader_: 'Drone is present in a database',
          presentDroneHeaderSubtitle_:
            'This drone is present in a database, please confirm if you want to add the following drone to the zone.',
          cancel_: 'Cancel',
          confirm_: 'Confirm',
          createdAt_: 'Created',
          serialNumber_: 'Serial number',
          danger_: 'Attention',
          dangerInfo_: 'This drone has already been declared.',
          noIdentificationDrones_: 'There are no drones added to the zone',
          forward_: 'Skip',
          back_: 'Back',
          id_: 'ID',
          delete_: 'Delete',
          error: "If you wish to add a drone please put down it's id",
        },
        finishedInfo: {
          in_: 'In',
          secondPart_: 'seconds you will be redirected to dashboard. Click',
          button_: 'here',
          lastPart_: 'if you want to move now.',
        },
      },
      editForm: {
        header_: 'Edit',
        textZone_: 'Zones',
        textActivation_: 'Activations',
        setType_: 'Type has been set to',
        tableId_: 'Id',
        tableFrom_: 'From',
        tableTo_: 'To',
        tableDel_: 'Delete',
        addButton_: 'Add',
        cancelButton_: 'Cancel',
        editZone_: 'Edit zone',
      },
      infoDetails: {
        temporary_: 'Temporary',
        permanent_: 'Permanent',
        periodic_: 'Periodic',
        private_: 'Private',
        public_: 'Public',
        contact_: 'Contact',
        noActivation_: 'No activation',
        type_: 'Type',
        fullName_: 'Full name',
        visibility_: 'Visibility',
        activationType_: 'Activation type',
        activationFromTo_: 'Activation',
        activationFrom_: 'from: ',
        activationTo_: 'to: ',
        activationDays_: 'Active in days',
        activationHours_: 'Active in hours',
        identification: {
          header_: 'IFF table',
          list_icao: 'ICAO/ID number',
          list_approval: 'Approval',
        },
      },
      allZones_: 'All',
    },
    roadMap: {
      type_: 'Map type',
      light: 'Light',
      outdoor: 'Outdoor',
      dark: 'Dark',
      street: 'Basic',
      satellite: 'Satellite',
      osm: 'Blue',
    },
    weather: {
      clear_sky_: 'Clear sky',
      few_clouds_: 'Few clouds',
      scattered_clouds_: 'Scattered clouds',
      broken_clouds_: 'Broken clouds',
      shower_rain_: 'Shower rain',
      rain_: 'Rain',
      thunderstorm_: 'Thunderstrom',
      snow_: 'Snow',
      mist_: 'Mist',
      thunderstorm_with_light_rain_: 'Thunderstorm with light rain',
      thunderstorm_with_rain_: 'Thunderstorm with rain',
      thunderstorm_with_heavy_rain_: 'Thunderstorm with heavy rain',
      light_thunderstorm_: 'Light thunderstorm',
      heavy_thunderstorm_: 'Heavy thunderstorm',
      ragged_thunderstorm_: 'Ragged thunderstorm',
      thunderstorm_with_light_drizzle_: 'Thunderstorm with light drizzle',
      thunderstorm_with_drizzle_: 'Thunderstorm with drizzle',
      thunderstorm_with_heavy_drizzle_: 'Thunderstorm with heavy drizzle',
      light_intensity_drizzle_: 'Light intensity drizzle',
      drizzle_: 'Drizzle',
      heavy_intensity_drizzle_: 'Heavy intensity drizzle',
      light_intensity_drizzle_rain_: 'Light intensity drizzle rain',
      drizzle_rain_: 'Drizzle rain',
      heavy_intensity_drizzle_rain_: 'Heavy intensity drizzle rain',
      shower_rain_and_drizzle_: 'Shower rain and drizzle',
      heavy_shower_rain_and_drizzle_: 'Heavy shower rain and drizzle',
      shower_drizzle_: 'Shower drizzle',
      light_rain_: 'Light rain',
      moderate_rain_: 'Moderate rain',
      heavy_intensity_rain: 'Heavy intensity rain',
      very_heavy_rain: 'Very heavy rain',
      extreme_rain_: 'Extreme rain',
      freezing_rain_: 'Freezing rain',
      light_intensity_shower_rain_: 'Light intensity shower rain',
      shower_rain: 'Shower rain',
      heavy_intensity_shower_rain: 'Heavy intensity shower rain',
      ragged_shower_rain_: 'Ragged shower rain',
      light_snow_: 'Light snow',
      heavy_snow_: 'Heavy snow',
      sleet_: 'Sleet',
      shower_sleet_: 'Shower sleet',
      light_shower_sleet: 'Light shower sleet',
      light_rain_and_snow: 'Light rain and snow',
      rain_and_snow_: 'Rain and snow',
      light_shower_snow_: 'Light shower snow',
      shower_snow_: 'Shower snow',
      heavy_shower_snow_: 'Heavy shower snow',
      smoke_: 'Smoke',
      haze_: 'Haze',
      sand_dust_whirls_: 'Sand dust whirls',
      fog_: 'Fog',
      sand_: 'Sand',
      dust_: 'Dust',
      volcanic_ash_: 'Volcanic ash',
      squalls_: 'Squalls',
      tornado_: 'Tornado',
      overcast_clouds_: 'Overcast clouds',
      legendBar: {
        temperature_: 'Temperature',
        wind_: 'Wind speed, m/s',
        pressure_: 'Pressure, hPa',
        clouds_: 'Cloudy',
      },
    },
    weekDays: {
      monday_: 'Monday',
      tuesday_: 'Tuesday',
      wednesday_: 'Wednesday',
      thursday_: 'Thursday',
      friday_: 'Friday',
      saturday_: 'Saturday',
      sunday_: 'Sunday',
    },
    allOperationsTable: {
      tableColumns: {
        id_: 'Id',
        start_: 'Start',
        stop_: 'Stop',
        status_: 'Status',
        icao_: 'Icao',
        aglMax_: 'Height AGL',
        zoomIn_: 'Zoom in',
      },
      filtersType: {
        status_: 'Status',
        icao_: 'Icao',
        heightAgl_: 'Height AGL',
      },
    },
    uavoDetails: {
      id_: 'Id',
      type_: 'Type',
      desc_: 'Description',
      speed_: 'Speed',
      speedUnit_: 'kph',
      altitude_: 'Altitude',
      altitudeUnit_: ' AMSL',
      lon_: 'Longitude',
      lat_: 'Latitude',
      track_: 'Azymut',
      sources_: 'Sources',
      ids_: 'Ids',
      loadingWeather_: 'Loading weather data...',
      noWeatherData_: 'No weather data',
      heightUnit_: 'm AGL',
      weather_: 'Weather - location: ',
      temperature_: 'Temperature / perceived temperature ',
      wind_: 'Wind / wind direction',
      weatherCondition_: 'Weather conditions',
      button_: 'Select',
      follow_: 'Follow',
      zoom_: 'Zoom in',
      noItems_: 'No uav selected.',
      windParser: {
        north_: 'North',
        northEast_: 'North-east',
        east_: 'East',
        southEast_: 'South-east',
        south_: 'South',
        southWest_: 'South-west',
        west_: 'West',
        northWest_: 'North-west',
      },
      aircrafts: {
        icao_: 'ICAO',
        baroAltitude_: 'Bar altitude',
        verticalSpeed_: 'Vertical speed',
        originCountry_: 'Origin country',
      },
    },
    operationsDetails: {
      current_: 'Current',
      allMissions_: 'All',
      headerMessage_: 'Choose drone icon on map to display operatrion details',
      operationsListHeader_: 'Operations',
      selectedUavosHeader_: 'Marked objects',
      operationDetails: {
        id_: 'Operation Id',
        startTime_: 'Start',
        endTime_: 'Stop',
        phone_: 'Phone',
        heightMax_: 'Height max',
        heightMin_: 'Height min',
        extraInfo_: 'Additional information',
        noExtraInfo_: 'Not provided',
        button_: 'Select',
      },
    },
    areas: {
      main: {
        header_: 'Approved Areas Management Module',
        button_: 'New',
      },
      list: {
        header_: 'List of all approved areas',
        name_: 'Name',
        desc_: 'Description',
        min_: 'Minimal height',
        max_: 'Maximal height',
        width_: 'Width',
        preview_: 'Edit',
        toolTipInfo_: 'Changes chart type',
        labelInfoArea_: 'Area chart',
        labelInfoStepped_: 'Stepped chart',
        chartWarning_: 'There is not enough data to display the chart',
        notPolygon: 'No chart available. There is no data on the height',
        loading_: 'Loading Areas Management Module...',
        noAreas_: 'There is no corridors to display.',
        deleteForm: {
          confirmButton_: 'Delete',
          cancelButton_: 'Back',
          confirmationText_: 'Are you sure you want to delete approved area?',
          areaNameText_: 'Area name',
        },
      },
      add: {
        header_: 'Create air holes',
        formFields: {
          name_: 'Name',
          desc_: 'Description',
          min_: 'Min height',
          max_: 'Max height',
          width_: 'Width',
          type_: 'Data source',
          button_: 'Save',
          visibility_: 'Visibility',
          private_: 'Private',
          public_: 'Public',
          zoneType_: 'Type',
          contact_: 'Contact',
          zoneCategory_: 'Zone category',
        },
        map: {
          height_: 'Height',
          width_: 'Width',
          line_: 'Draw zone',
          clear_: 'Clear',
          selectFile_: 'Select file',
          fileFormat_: 'Available .kml files with line geometry',
          polygon_: 'Mark zone',
          circle_: 'Draw circle',
        },
      },
      edit: {
        header_: 'Edit area',
        formFields: {
          name_: 'Name',
          desc_: 'Description',
          min_: 'Min height',
          max_: 'Max height',
          width_: 'Width',
          type_: 'Data source',
          button_: 'Save',
          editToggleButton_: 'Edit',
          visibility_: 'Visibility',
          private_: 'Private',
          public_: 'Public',
          zoneType_: 'Type',
          contact_: 'Contact',
          click_: 'Click',
          here_: 'Here',
          restInfo_: 'to add drones to zone.',
        },
      },
      placeholderForm: {
        required: 'This field is required',
        text: ', min. 3 characters, max. 50 characters',
        description: ', min. 3 characters, max. 250 characters',
        email: ', in the format: john.smith@hawk-e.com.pl',
        number: ', just enter the numbers',
        phone: ', enter a valid phone number',
        phonePattern: 'Telephone contact, in the format: XXX XXX XXX',
        nameExsits_: ', name already exists',
      },
    },
    approvedAreasDetails: {
      listHeader_: 'Selected air corridor details',
      name_: 'Name',
      approvedAreasDetails_: 'Corridors',
      desc_: 'Description',
      min_: 'Minimal height',
      max_: 'Maximum height',
      width_: 'Width',
      editHeader_: 'Manage approved area',
      editButton_: 'Edit approved area',
    },
    userSettings: {
      userSettings_: 'User settings',
      profileSettings_: 'Profile settings',
      dashboardSettings_: 'Dashboard configuration',
      mainSettings: {
        defaultLanguage_: 'Language',
        defaultTheme_: 'Theme',
        defaultFontSize_: 'Font size',
        defaultThemeOptions: {
          light: {
            key_: 'Light',
            value_: 'light',
          },
          dark: {
            key_: 'Dark',
            value_: 'dark',
          },
        },
        defaultFontSizeOptions: {
          small: {
            key_: 'Small',
            value_: 0.6,
          },
          normal: {
            key_: 'Normal',
            value_: 0.7,
          },
          large: {
            key_: 'Large',
            value_: 1,
          },
        },
        language: {
          en_: 'English',
          pl_: 'Polish',
        },
      },
    },
    filters: {
      ruler: {
        start: 'Click on the map to start measuring the distance.',
        mouseButton: 'Double click',
        stop: ' on map to stop',
      },
      popup: {
        distance: 'Distance',
        changeDistance: 'Change dimesion',
      },
      uavos: {
        type_: 'Source type',
        noData_: 'No data',
        header_: 'Pick sources',
        drones_: 'Drones',
        aircrafts_: 'Aircrafts',
      },
    },
    userProfile: {
      header_: 'Edit your data:',
      button_: 'Save',
      title_: 'Your profile',
      formFields: {
        firstName_: 'First name',
        lastName_: 'Last name',
        username_: 'Username',
        email_: 'Email',
        phone_: 'Phone number',
        password_: 'Password',
        rePassword_: 'Repeat password',
        city_: 'City',
        street_: 'Street',
        number_: 'Number',
      },
    },
    adminZone: {
      header_: 'Welcome in admin zone.',
      menuOptions: {
        first_: 'Organizations',
        second_: 'Users',
        third_: 'Permissions',
        four_: 'Manage zones',
        fifth_: 'System settings',
      },
      addOrganization: {
        header_: 'Add organization',
        formFields: {
          drawOrg_: `Choose file or draw organization's borders: `,
          name_: 'Name of organization',
          phone_: 'Telephone number',
          city_: 'City',
          street_: 'Street',
          number_: 'Number of building',
          email_: 'Email',
          nip_: 'NIP number',
          regon_: 'REGON number',
          buffer_: 'Jurisdiction buffer',
          addButton_: 'Add',
          editButton_: 'Edit',
          button_: 'Save',
          deleteButton_: 'Delete',
          editInform_: 'You are in edit mode',
        },
        selectedOrgTitle_: 'Selected master organization',
        notSelectedOrgTitle_: 'You are creating master organization',
        existingOrgs: {
          orgTitle_: 'Organization',
          city_: 'City',
          street_: 'Street',
          number_: 'Local number',
          phone_: 'Phone number',
          expandTitleSlaves_: 'Show lower level organizations',
          slaveOrgTitle_: 'Lower level organization',
          button_: 'Select',
          addExistingOrganization_: 'Click to add lower level organization',
        },
        iconsLabels: {
          polygon_: 'Mark zone',
          line_: 'Draw line',
          point_: 'Mark point',
          circle_: 'Draw circle',
          clear_: 'Clear',
          zoneHeight_: 'Select height of zone',
          selectFile_: 'Select file',
          fileFormat_: 'Available .kml files',
        },
        preview_: 'Preview',
      },
      editOrganization: {
        header_: 'Preview organization',
        formFields: {
          drawOrg_: `Choose file or draw organization's borders: `,
          name_: 'Organization name',
          phone_: 'Phone number',
          city_: 'City',
          street_: 'Street',
          number_: 'Building number',
          email_: 'Email',
          nip_: 'NIP number',
          regon_: 'REGON number',
          buffer_: 'Jurisdiction buffer',
          button_: 'Save',
          addButton_: 'Add',
          editButton_: 'Edit',
          cancelEditButton_: 'Cancel',
          deleteButton_: 'Delete',
          editInform_: 'You are in edit mode',
        },
        iconsLabels: {
          polygon_: 'Mark area',
          line_: 'Draw the line',
          point_: 'Mark point',
          circle_: 'Draw the circle',
          clear_: 'Delete',
          zoneHeight_: 'Define approved area height',
          selectFile_: 'Select file',
          fileFormat_: 'Available .kml files',
        },
        selectedOrgTitle_: 'You are editing approved area',
      },
      userList: {
        header_: 'Users',
        noUsers_: 'There is any user added yet.',
        belongingOrganization_: 'Belonging organization',
        preview_: 'Preview',
        active_: 'Active',
        inactive_: 'Disabled',
        user_: 'User',
        address_: 'Address',
        phoneNumber_: 'number',
        mail_: 'e-mail',
        organization_: 'Organization',
        loginInfo: {
          seen_: 'Last seen',
          notSeen_: 'Never logged in',
        },
        organizationData_: 'Data not downloaded',
      },
      user: {
        addUserButton_: 'Add',
        editUserButton_: 'Save',
        activeUsers: 'Active',
        inactiveUsers: 'Inactive',
        header_: 'Edit user',
        button_: 'Save',
        formFields: {
          firstName_: 'First name',
          lastName_: 'Last name',
          username_: 'Username',
          email_: 'Email',
          phone_: 'Phone number',
          city_: 'City',
          street_: 'Street',
          number_: 'Number',
          organization_: 'Select organization for user',
          userGroups_: 'Set users group for user',
          checkBoxGroupInfo_: 'Choose at least one group',
        },
        addUser: {
          header_: 'Add new user',
          button_: 'Add',
          formFields: {
            firstName_: 'First name',
            lastName_: 'Last name',
            username_: 'Username',
            email_: 'Email',
            phone_: 'Phone number',
            password_: 'Password',
            rePassword_: 'Repeat password',
            city_: 'City',
            street_: 'Street',
            number_: 'Number',
            organization_: 'Select organization for user',
            userGroups_: 'Set users group for user',
            checkBoxGroupInfo_: 'Choose at least one group',
          },
        },
      },
      permissions: {
        header_: 'Manage permissions',
        manageUserPermission: {
          admin_: 'Manage admin permission for user',
          active_: 'Disable user',
          email_: 'Manualy verify email address',
          phone_: 'Manualy verify phone number',
          subTitle_: 'You are updating user',
        },
      },
      systemSettings: {
        header_: 'System settings',
        buttonText_: 'Save',
        drones_service_: 'Drones Service',
        ogn_: 'Ogn',
        common: {
          add_topic_: 'Add topic',
          area_: 'Area',
          common_: 'Common Settings',
          mqtt_pass_: 'Mqtt password',
          mqtt_port_: 'Mqtt server port',
          mqtt_server_: 'Mqtt server address',
          mqtt_user_: 'Mqtt username',
          no_data_: 'No data to display',
          password_: 'Password',
          port_: 'Port',
          redis_: 'redis server (vehicles other than drones)',
          redis_cache_: 'redis_cache server (vehicles other than drones)',
          redis_drone_: 'redis_drone server',
          redis_drone_cache_: 'redis_drone_cache server',
          redis_drone_main_: 'redis_drone_main server',
          redis_exp_: 'Redis expiration time (in seconds)',
          redis_main_: 'redis_main server (vehicles other than drones)',
          redis_port_: 'Port on which redis services works',
          source_url_: 'Source url',
          srtm_server_: 'SRTM server addres',
          topics_: 'Topics',
          user_: 'Username',
        },
        hertz: {
          header_: 'Hertz System',
          topicsIn_: 'Topics for incoming data',
          topicOut_: 'Topics for outgoing data',
          stationBuffer_: 'Hertz station buffer radius',
        },
        aerobits: {
          aerobits_: 'Aerobits',
          add_topic_: 'Add another topic',
        },
        aps: {
          aps_: 'APS',
          radars_: 'Radars urls',
          dtm_uavos_url_: 'Url for saving drones',
          add_topic_: 'Add another data source',
        },
        atam: {
          atam_: 'ATAM',
          interval_drones_: 'Drones interval',
          interval_uavos_: 'Uavo interval',
          iff_enabled_: 'IFF enabled',
        },
        drones_service: {
          drones_service_: 'Drones Service',
          add_topic_: 'Add topic',
        },
        open_sky: {
          open_sky_: 'Open Sky',
          area_: 'Area',
          os_user_: 'Username',
          os_pass_: 'Password',
          os_url_: 'Source url address',
        },
        ufs: {
          ufs_: 'UFS',
          interval_: 'Interval (in seconds)',
          lon_buffer_: 'Longitude buffer (in meters)',
          lat_buffer_: 'Latitude buffer (in meters)',
          height_buffer_: 'Height buffer (in meters)',
          azimuth_buffer_: 'Azimuth buffer (in deegres)',
        },
        utm: {
          utm_: 'UTM',
          utm_exp_: 'Redis expiration time (in seconds)',
          dtm_operations_url_: 'DTM url address',
          utm_operations_url_: 'Source url address',
        },
        core: {
          core_: 'Core',
          zones_url_: 'UTM zones url',
          zones_types_url_: 'UTM zones types url',
          ogn_models_: 'OGN models database url',
          open_sky_db_: 'Open Sky aircrafts database url',
          open_sky_types_: 'Open Sky aircrafts typs url',
          missions_url_: 'UTM missions url',
          weather_url_: 'Weather service url',
          weather_api_: 'Weather API key',
          email_use_ssl_: 'Use SSL',
          email_host_: 'Email server address',
          email_port_: 'Email server port',
          email_host_user_: 'Email username',
          email_host_password_: 'Email password',
          default_from_email_: 'Default "from" email',
        },
        editSettings: {
          save_: 'Save',
        },
      },
      subscriptions: {
        header_: 'Subscriptions',
        noSubscriptions_: 'No subscriptions',
        id_: 'ID',
        created_: 'Created',
        start_: 'Subscription start',
        stop_: 'Subscription stop',
        active_: 'Status',
        organization_: 'Organization',
        payments: {
          header_: 'Payments',
          created_: 'Created',
          invoice_number_: 'Invocie number',
          payment_till_: 'Payment till ',
          payment_booked_: 'Booking date',
          discount_: 'Discount',
        },
        add_: 'Add subscription',
        form: {
          organization_: 'Select organization',
          plan_: 'Select subscription plan',
          dates_: 'Start and end of a subscription',
          planCategory_: 'Subscription plan category',
          planType_: 'Payment type',
          planCost_: 'Cost',
          planDesc_: 'Description',
        },
      },
    },
    dashboardConfig: {
      title_: 'Dashboard configuration',
      zones: {
        title_: 'Manage zones type',
        approvedAreas_: 'Corridores',
        noData_: 'No zone types',
      },
      uavos: {
        title_: 'Manage sources',
        all_: 'All',
        simulator_: 'Simulator',
        utm_: 'UTM',
        aircrafts_: 'Aircrafts',
      },
    },
    contactModule: {
      header_: 'Contact',
      subHeader_: 'Write us a message',
      formFields: {
        topic_: 'What is the reason of contact',
        desc_: 'Please describe your problem',
        button_: 'Send',
      },
    },
    alerts: {
      loginError: {
        title_: 'Login error',
        desc_: 'Cant access using provided credentials',
      },
      loginSuccess: {
        title_: 'Successfuly logged in!',
        desc_: 'You are logged in successfuly',
      },
      requestError: {
        title_: 'Fetching data error',
        desc_: 'Failed to fetch data',
      },
      dataProccessError: {
        title_: 'Data proccess error',
        desc_: 'While data proccessing an error has occured',
      },
      sendingEmailError: {
        errorDesc_: `Mail doesn't exist`,
        msgDesc_: `Error 400: The server was unable to process the request`,
      },
      addDataSuccess: {
        title_: 'Success',
        desc_: 'Successfuly added data',
      },
      requestWarning: {
        title_: 'Not founded',
        desc_: 'Failed to fetch data with given criteria',
      },
      noResults: {
        title_: 'No result',
        desc_: 'There is no result in given period',
      },
      noUsersAlert: "You haven't added any user yet.",
      weatherFail: {
        title_: 'No results',
        desc_: 'Weather for these coordinates could not be found',
      },
      mapInfoTooLargeDashboard: {
        title_: 'Map is too large',
        desc_: 'Map could not be greater than whole screen.',
      },
      mapInfoTooLarge: {
        title_: 'Map is too large',
        desc_: 'Map could not be greater than 60% of the page.',
      },
      mapInfoTooSmallDashboard: {
        title_: 'Mapa is too small',
        desc_: 'Map could not be smaller than 30% of the page.',
      },
      mapInfoTooSmall: {
        title_: 'Mapa is too small',
        desc_: 'Map could not be smaller than 40% of the page.',
      },
      deleteSuccess: {
        title_: 'Deleted!',
        desc_: 'Element deleted properly.',
      },
      deleteError: {
        title_: 'Warning',
        desc_: 'Something went wrong and element could not be removed.',
      },
      1: {
        title_: 'Incorrect data',
        desc_: 'The payload you have sent was incorrect.',
      },
      2: {
        title_: 'Geometry error',
        desc_: 'Given geometry is outside Parent’s jurisdiction.',
      },
      3: {
        title_: 'Email error',
        desc_: 'There was an error sending email.',
      },
      4: {
        title_: 'Email error',
        desc_: 'The email does not exist.',
      },
      5: {
        title_: 'Geometry error',
        desc_: `Given geometry is outside organization's geometry`,
      },
      6: {
        title_: 'Geometry error',
        desc_: `Given geometry is invalid.`,
      },
      7: {
        title_: 'Error',
        desc_: `Something bad happened during the server procedure`,
      },
      8: {
        title_: 'Token error',
        desc_: `Token is not valid.`,
      },
      9: {
        title_: 'Unathorized',
        desc_: `Action is unauthorized.`,
      },
      200: {
        title_: 'Success',
        desc_: 'Successfuly added data',
      },
      400: {
        title_: 'Bad Request',
        desc_: `Something bad happened during the server procedure`,
      },
      screenResolution: {
        desc1_: 'Your screen resolution is ',
        desc2_: `pixels and the system may not behave as${'\u00A0'}expected.\nThe screen should${'\u00A0'}be at${'\u00A0'}least `,
        desc3_: `pixels wide and at${'\u00A0'}least `,
        desc4_: 'pixels high.',
      },
      fileExport: {
        title_: 'File export',
        desc_: 'File has been exported properly.',
      },
    },
    map: {
      tileConfigurator: {
        removeWeatherLayer_: 'Dont show weather maps',
        expandMaps_: 'Weather maps',
        hideMaps: 'Hide',
        temperature_: 'Temperature map',
        pressure_: 'Pressure map',
        wind_: 'Wind map',
        clouds_: 'Cloud cover map',
        precipitation_: 'Precipitation map',
      },
      resizer: {
        greatenMap_: 'Increase map size ',
        reduceMap_: 'Reduce map size',
        centerMap_: 'Center map',
      },
    },
    drawMap: {
      tooltip_: 'Show objects on map',
    },
    errors: {
      required: 'Field is required',
      onlyNumbersAndLetters_:
        'This string can contain only numbers or letters.',
      passwordRequirements_:
        'Password requirements are: capital letter, at least one number, special char, length from  8 to 40.',
      phoneRequirements_:
        'Phone numer could start from +48/00 or it could start without it, needs to be from 7 to 32 length.',
    },
    tables: {
      expression_: ' of ',
      moreThen_: ' more then ',
    },
    utcInfo_: 'You are editing in UTC timezone.',
    userPermissionList: {
      org_admin_: 'Organization admin / Manager',
      controller_: 'Controller',
      reader_: 'Reader',
      reporter_: 'Reporter',
    },
    exportButton: {
      fetchingDataInfo_: 'Fetching data...',
      export_: 'Export',
      fileTypeInfo_: 'Choose file extension',
      cancel_: 'Cancel',
    },
  },
};
